import { ComponentProps, FC } from 'react'
import { ColoredTitleImg } from './styled'

type Props = ComponentProps<typeof ColoredTitleImg> & {
  src: [string, string, string]
}

export const ColoredTitle: FC<Props> = ({
  src: [small, medium, large],
  ...props
}) => (
  <ColoredTitleImg
    {...props}
    srcSet={`${small} 350w, ${medium} 1017w, ${large} 1580w`}
    src={large}
    alt="Colored title"
  />
)
